<template>
  <div>
    <div
      class="floor-product-img"
      v-if="contentInfo.image"
      @click="gotoProduct"
    >
      <img class="img" :src="contentInfo.image" alt="" />
    </div>
    <div class="floor-product-box" v-else>
      <div class="floor-product" @click="gotoProduct">
        <div class="floor-product-title-box">
          <div class="floor-product-title">
            {{ productInfo.country_name }}{{ productInfo.visa_type
            }}{{ entryLabel }}
          </div>
          <div class="floor-product-sub-title">
            {{ productInfo.product_special_desc }}
          </div>
        </div>
        <div
          class="floor-product-label"
          v-if="productInfo.tag && productInfo.tag.length > 0"
        >
          <div
            class="floor-product-label-item"
            v-for="(item, index) in productInfo.tag"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="floor-product-bottom">
          <div class="floor-product-days">
            {{ productInfo.summary }}
          </div>
          <div class="floor-product-count">{{ productInfo.sales }}人已办理</div>
          <div class="floor-product-price">
            ￥<span>{{ productInfo.sell_price / 100 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dev from '../../../services/dev.js';
import Base64 from '../base64.js';
import utils from '../../../services/tools.js';

export default {
  name: 'floor-product',
  props: {
    contentInfo: Object,
  },
  data() {
    return {
      is_in_app: 0,
      is_in_wxa: false,
      validityPeriodMap: {
        0: '天',
        1: '月',
        2: '年',
      },
      numberMap: {
        1: '一',
        2: '两',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九',
      },
    };
  },
  computed: {
    productInfo() {
      return this.contentInfo.product_info;
    },
    entryLabel() {
      // 入境次数展示
      if (this.productInfo.entry_count_unit === 2) {
        return '';
      } else if (this.productInfo.entry_count_unit === 0) {
        // *次入境
        let entryCountStr =
          this.numberMap[this.productInfo.entry_count_n] ||
          this.productInfo.entry_count_n;
        entryCountStr += '次入境';
        return `·${entryCountStr}`;
      } else if (this.productInfo.entry_count_unit === 1) {
        if (this.validityPeriodMap[this.productInfo.validity_period_unit]) {
          const validityPeriodNum =
            this.numberMap[this.productInfo.validity_period_n] ||
            this.productInfo.validity_period_n;
          const validityPeriodUnit =
            this.validityPeriodMap[this.productInfo.validity_period_unit] || '';
          return `·${validityPeriodNum + validityPeriodUnit}多次入境`;
        }
        return '·多次入境';
      }
      return '';
    },
  },
  created() {
    this.is_in_app = this.$route.query.is_in_app || 0;
  },
  methods: {
    gotoProduct() {
      let url = '';
      if (utils.isJDWxa()) {
        jd.miniProgram.navigateTo({
          url: `/pages/product/product-detail/product-detail?visa_product_id=${this.productInfo.visa_product_id}`,
        });
        return;
      } else if (utils.isWxa()) {
        wx.miniProgram.navigateTo({
          url: `/pages/visa/visa-detail?visa_product_id=${this.productInfo.visa_product_id}`,
        });
        return;
      } else if (this.is_in_app) {
        const args = { visa_product_id: this.productInfo.visa_product_id };
        url = `pandavisa://jump_page?page_id=16&args=${Base64.encode(
          JSON.stringify(args),
        )}`;
      } else if (
        this.$route.query &&
        this.$route.query.distributor_id &&
        this.$route.query.distributor_id === '10008'
      ) {
        // 此处是单独给天际通的，先写死，后面会出原型优化掉
        url = `https://${dev}m.11visa.com/?distributor_id=10008&theme=red&open_type=0/#/product/${this.productInfo.visa_product_id}`;
      } else if (
        this.$route.query &&
        this.$route.query.distributor_id &&
        this.$route.query.distributor_id === '10001'
      ) {
        // 此处是单独给无忧行的，先写死，后面会出原型优化掉
        url = `https://${dev}m.11visa.com/?distributor_id=10001&theme=red&open_type=0/#/product/${this.productInfo.visa_product_id}`;
      } else {
        url = `https://${dev}m.11visa.com/#/product/${this.productInfo.visa_product_id}`;
      }
      window.location.href = url;
    },
  },
};
</script>
<style lang="less" scoped>
.floor-product-img {
  width: 100%;
  font-size: 0;
  .img {
    width: 100%;
  }
}
.floor-product-box {
  padding: 0.05rem 0.1rem;
}
.floor-product {
  box-sizing: border-box;
  border-radius: 0.03rem;
  padding: 0.175rem 0.15rem;
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0rem 0.01rem 0.08rem 0rem rgba(0, 0, 0, 0.1);
}
.floor-product-title-box {
  display: flex;
  line-height: 1.2;
  align-items: baseline;
  margin-bottom: 0.075rem;
  .floor-product-title {
    max-width: 90%;
    flex-shrink: 0;
    font-size: 0.16rem;
    color: #444444;
    margin-right: 0.08rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .floor-product-sub-title {
    font-size: 0.12rem;
    color: #6f6f6f;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.floor-product-label {
  font-size: 0;
  height: 0.17rem;
  overflow: hidden;
  margin-right: -0.03rem;
  .floor-product-label-item {
    box-sizing: border-box;
    padding: 0 0.05rem;
    line-height: 0.15rem;
    font-size: 0.1rem;
    border-radius: 0.08rem;
    border: solid 1px #ffa8ab;
    color: #ffa8ab;
    display: inline-block;
    margin-right: 0.03rem;
    margin-bottom: 0.03rem;
  }
}
.floor-product-bottom {
  margin-top: 0.14rem;
  display: flex;
  font-size: 0;
  align-items: baseline;
  .floor-product-days {
    flex-grow: 0;
    line-height: 1;
    color: #aaaaaa;
    font-size: 0.12rem;
    display: flex;
    align-items: center;
    background: url('../../../assets/imgs/date_icon.png') no-repeat left center;
    background-size: 0.12rem 0.12rem;
    padding-left: 0.17rem;
    &::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 0.1rem;
      background-color: #aaa;
      margin-left: 0.05rem;
    }
  }
  .floor-product-count {
    flex-grow: 1;
    line-height: 1;
    color: #aaaaaa;
    font-size: 0.12rem;
    padding-left: 0.05rem;
    display: flex;
    align-items: center;
  }
  .floor-product-price {
    color: #ff5a60;
    font-weight: 600;
    font-size: 0.14rem;
    line-height: 1;
    span {
      font-size: 0.23rem;
    }
  }
}
</style>
